import { Horizontal } from "Components/Horizontal";
import { Checkbox } from "Inputs/Checkbox";
import { Textbox } from "Inputs/Textbox";
import React from "react";

export interface SignatureInputProps {
  ApplicantName?: string;
  PremiumFullyEarnedWording: string;
}

export function SignatureInput(
  props: SignatureInputProps & {
    isCheckbox?: boolean;
  },
) {
  return (
    <>
      <Horizontal label="Acknowledgement" shouldNotPadLabel>
        <div>
          <div className="is-italic">
            Any person who, with intent to defraud or knowing that he or she is
            facilitating a fraud against an insurer, submits an application or
            files a claim containing a false or deceptive statement may be
            guilty of insurance fraud and may be subject to{" "}
            <span className="has-text-weight-bold">
              civil fines and criminal punishment
            </span>
            . {props.PremiumFullyEarnedWording}
          </div>
          <div className="has-text-weight-bold" style={{ marginTop: "1.5em" }}>
            I certify that the information provided in this application is
            correct in its entirety, to the best of my knowledge.
          </div>
          <div className="is-italic" style={{ marginTop: "1.5em" }}>
            {props.isCheckbox ? (
              <>
                By checking the box next to my name I agree to comply with this
                requirement:
              </>
            ) : (
              <>
                Please type your name in the box below as your digital
                signature:
              </>
            )}
          </div>
        </div>
      </Horizontal>
      <Horizontal
        isRequired={!props.isCheckbox}
        label={!props.isCheckbox && "Signature"}
        fieldId="Signature"
      >
        {props.isCheckbox ? (
          <Checkbox fieldName="Signature">{props.ApplicantName}</Checkbox>
        ) : (
          <Textbox fieldName="Signature" placeholder="Signature" />
        )}
      </Horizontal>
    </>
  );
}
